import fetch from '@rd-web-markets/shared/dist/services/Fetcher';
import { request } from '@rd-web-markets/shared/dist/services/request';
import QueryString from 'query-string';
const qeAndRndIntensityService = {
  all(companyId, businessUnits, subsidiary_company_ids, years) {
    const query = QueryString.stringify({
      business_units: businessUnits,
      subsidiary_company_ids: subsidiary_company_ids,
      years: years
    }, {
      arrayFormat: 'comma'
    });
    return fetch("/api/companies/".concat(companyId, "/qe_and_rnd_intensities?").concat(query), request.get);
  }
};
export default qeAndRndIntensityService;